<template>
  <div style="background-color:black; height:100vh;">
    <div fill-height fluid class="ma-0">
      <!-- Back Button -->
      <v-btn icon class="back-button" @click="confirmBackNavigation">
        <v-icon class="white--text">mdi-arrow-left</v-icon>
      </v-btn>

      <!-- Page Header -->
      <v-row class="pa-7" justify="center">
        <h2 class="red--text">Edit Spare</h2>
      </v-row>

      <!-- Form Card -->
      <v-row class="fill-height pa-0 ma-0" justify="center" align="start">
        <v-col cols="12" md="12" class="pa-0">
          <v-card elevation="0" class="add-spares-card">
            <v-card-text>
              <!-- Loading Overlay -->
              <v-overlay :value="loading">
                <v-progress-circular indeterminate size="64" color="red"></v-progress-circular>
              </v-overlay>

              <!-- Form Header -->
              <v-row>
                <h2 class="red--text mx-12" style="margin-bottom: 30px;">SPARES DETAILS</h2>
                <v-spacer></v-spacer>
              </v-row>

              <!-- Spares Form -->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <!-- Spares ID (Read-Only) -->
                  <v-col cols="12" md="1">
                    <v-text-field
                      v-model="sparesId"
                      label="Spares ID"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-identifier"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Status Dropdown (Editable) -->
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="status"
                      :items="statusOptions"
                      label="Status"
                      outlined
                      dense
                      prepend-inner-icon="mdi-status"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      @change="handleStatusChange"
                    ></v-select>
                  </v-col>

                  <!-- Journal Number (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="journalNumber"
                      label="Journal Number"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-file-document"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Journal Credit Number (Editable only if status === 'Completed') -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="journalCreditNumber"
                      label="Journal Credit Number"
                      dense
                      outlined
                      :readonly="status !== 'Completed'"
                      prepend-inner-icon="mdi-file-document-outline"
                      class="pa-0 montserrat-input"
                      :rules="status === 'Completed' ? [rules.required] : []"
                    ></v-text-field>
                  </v-col>

                  <!-- Shipment Number (Editable only if status === 'Completed') -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="shipmentNumber"
                      label="Shipment Number"
                      dense
                      outlined
                      :readonly="status !== 'Completed'"
                      prepend-inner-icon="mdi-truck-delivery"
                      class="pa-0 montserrat-input"
                      :rules="status === 'Completed' ? [rules.required] : []"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Bin Number Dropdown (Disabled) -->
                  <v-col cols="12" md="1">
                    <v-select
                      v-model="binNumber"
                      :items="availableBinsWithCurrent"
                      label="Bin"
                      outlined
                      dense
                      prepend-inner-icon="mdi-archive"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      :disabled="true"
                    ></v-select>
                  </v-col>

                  <!-- Created Date (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="createdDate"
                      label="Created Date"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-calendar-text"
                      class="pa-0 montserrat-input"
                    ></v-text-field>
                  </v-col>

                  <!-- 4 Week Projected Date (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="projectedDate"
                      label="4 Week Projected Date"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      class="pa-0 montserrat-input"
                    ></v-text-field>
                  </v-col>

                  <!-- Free of Charge Dropdown (Disabled) -->
                  <v-col cols="12" md="2">
                    <v-select
                      v-model="freeOfCharge"
                      :items="freeOfChargeOptions"
                      label="Free of charge"
                      outlined
                      dense
                      prepend-inner-icon="mdi-tag"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      :disabled="true"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Reason Dropdown (Disabled) -->
                  <v-col cols="10" md="8" class="pa-2">
                    <v-select
                      v-model="reason"
                      :items="reasonOptions"
                      label="Reason"
                      outlined
                      dense
                      prepend-inner-icon="mdi-comment-text-outline"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      :disabled="true"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Quantity (Read-Only) -->
                  <v-col cols="12" md="1">
                    <v-text-field
                      v-model="qty"
                      label="Quantity"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-numeric"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required, rules.numeric, rules.minValue]"
                    ></v-text-field>
                  </v-col>

                  <!-- Code (Read-Only) -->
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="code"
                      label="Code"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-barcode"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Description (Read-Only) -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="description"
                      label="Description"
                      dense
                      outlined
                      readonly
                      prepend-inner-icon="mdi-information-outline"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <!-- Image View & Download Buttons -->
                  <v-col cols="12" md="3" class="d-flex align-center">
                    <!-- View Image Button -->
                    <v-btn
                      icon
                      color="primary"
                      @click="openImageDialog"
                      class="pa-0 montserrat-input"
                      aria-label="View Photo"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                    <!-- Download Photo Button -->
                    <v-btn
                      icon
                      color="primary"
                      @click="downloadImage"
                      class="pa-0 montserrat-input"
                      aria-label="Download Photo"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <!-- Display Image Thumbnail -->
                    <div v-if="imageUrl" class="ml-2">
                      <v-img
                        :src="imageUrl"
                        max-width="50"
                        max-height="50"
                        contain
                      ></v-img>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- Comment (Read-Only) -->
                  <v-col cols="12" md="8" class="pa-2">
                    <v-textarea
                      v-model="comment"
                      label="Comment"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-comment"
                      class="pa-0 montserrat-input"
                      :rules="[rules.required]"
                      rows="3"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- Save Button -->
                <v-row justify="center">
                  <v-btn
                    dark
                    large
                    width="300px"
                    @click="confirmSubmit"
                    class="montserrat-button pa-0"
                    :disabled="loading"
                  >
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmationDialog.visible" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ confirmationDialog.title }}</v-card-title>
        <v-card-text>{{ confirmationDialog.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirmationDialog.confirm">Yes</v-btn>
          <v-btn color="grey darken-1" text @click="confirmationDialog.visible = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image View Dialog -->
    <v-dialog v-model="imageDialog.visible" max-width="600px">
      <v-card>
        <v-card-title class="headline">Uploaded Photo</v-card-title>
        <v-card-text class="text-center">
          <v-img :src="imageUrl" contain max-height="500px"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeImageDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarMessage }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { firebaseApp } from "@/firebaseConfig"; // Adjust the path as needed

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export default {
  data() {
    return {
      loading: false,
      valid: false,
      spareDocId: "", // Firestore Document ID for the spare
      sparesId: "",
      status: "",
      journalNumber: "",
      journalCreditNumber: "",
      shipmentNumber: "",
      freeOfCharge: "",
      binNumber: "",
      createdDate: "",
      projectedDate: "",
      reason: "",
      qty: "",
      code: "",
      description: "",
      imageFile: null,
      imageUrl: "",
      comment: "",
      confirmationDialog: {
        visible: false,
        title: "",
        message: "",
        confirm: null,
      },
      imageDialog: {
        visible: false,
      },
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
      statusOptions: [
        { text: "Factory Repair", value: "Factory Repair" },
        { text: "Local Repair", value: "Local Repair" },
        { text: "Completed", value: "Completed" },
      ],
      freeOfChargeOptions: [
        { text: "Send F.O.C", value: "Send F.O.C" },
        { text: "Not F.O.C", value: "Not F.O.C" }
      ],
      reasonOptions: [
        "Used Parts",
        "Short Supply",
        "Modify parts",
        "Damaged parts",
        "Incorrect Supply",
      ],
      totalBins: Array.from({ length: 40 }, (_, i) => (i + 1).toString()),
      availableBins: [],
      // Define the rules to be used in form validation.
      rules: {
        required: (value) => !!value || "Required.",
        numeric: (value) => {
          if (value === null || value === undefined || value === "") return "Required.";
          return !isNaN(value) || "Must be numeric.";
        },
        minValue: (value) => parseInt(value, 10) > 0 || "Must be greater than zero.",
      },
    };
  },
  computed: {
    // Ensures that if a bin is already selected, it appears in the dropdown.
    availableBinsWithCurrent() {
      if (this.binNumber && !this.availableBins.includes(this.binNumber)) {
        return [...this.availableBins, this.binNumber].sort((a, b) => parseInt(a) - parseInt(b));
      }
      return this.availableBins;
    },
  },
  async created() {
    this.loading = true;
    await this.fetchSpares();
    await this.getSpareData();
    this.loading = false;
  },
  methods: {
    async fetchSpares() {
      try {
        // Fetch spares to determine which bins are taken (if needed)
        const sparesCollection = collection(db, "AwaitingSpares");
        const sparesSnapshot = await getDocs(sparesCollection);
        const takenBins = sparesSnapshot.docs
          .map((doc) => {
            const data = doc.data();
            return data.binNumber && data.status !== "Completed" ? data.binNumber.toString() : null;
          })
          .filter((bin) => bin);
        this.availableBins = this.totalBins.filter((bin) => !takenBins.includes(bin));
      } catch (error) {
        console.error("Error fetching spares:", error);
        this.snackbarMessage = "Failed to fetch spares.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    async getSpareData() {
      // Assume the selected spare's Firestore document ID is stored in localStorage
      const spareId = localStorage.getItem("selectedSpare");
      if (!spareId) {
        setTimeout(() => {
          this.$router.push({ path: "/AllSpares" });
        }, 100);
        return;
      }
      try {
        const spareDocRef = doc(db, "AwaitingSpares", spareId);
        const spareDoc = await getDoc(spareDocRef);
        if (spareDoc.exists()) {
          const data = spareDoc.data();
          this.spareDocId = spareId;
          this.sparesId = data.sparesId || "";
          this.status = data.status || "";
          this.journalNumber = data.journalNumber || "";
          this.journalCreditNumber = data.journalCreditNumber || "";
          this.shipmentNumber = data.shipmentNumber || "";
          this.freeOfCharge = data.freeOfCharge || "";
          this.binNumber = data.binNumber ? data.binNumber.toString() : "";
          this.createdDate = data.createdDate || "";
          this.projectedDate = data.projectedDate || "";
          this.reason = data.reason || "";
          this.qty = data.qty || "";
          this.code = data.code || "";
          this.description = data.description || "";
          this.comment = data.comment || "";
          this.imageUrl = data.imageUrl || "";
        }
      } catch (error) {
        console.error("Error fetching spare data:", error);
        this.snackbarMessage = "Failed to fetch spare data. Please try again later.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    handleStatusChange() {
      // When status changes, the Journal Credit Number and Shipment Number fields become editable only if status is "Completed"
      if (this.status !== "Completed") {
        this.journalCreditNumber = "";
        this.shipmentNumber = "";
      }
    },

    triggerImageUpload() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.imageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    openImageDialog() {
      this.imageDialog.visible = true;
    },

    closeImageDialog() {
      this.imageDialog.visible = false;
    },

    async downloadImage() {
      if (this.imageUrl) {
        try {
          this.loading = true;
          const response = await fetch(this.imageUrl);
          if (!response.ok) {
            throw new Error("Failed to fetch the image.");
          }
          const blob = await response.blob();
          const urlParts = this.imageUrl.split("/");
          const filename = urlParts[urlParts.length - 1].split("?")[0];
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename || "spare_image.jpg";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.snackbarMessage = "Image downloaded successfully.";
          this.snackbarColor = "success";
          this.snackbar = true;
        } catch (error) {
          console.error("Error downloading the image:", error);
          this.snackbarMessage = "Failed to download the image.";
          this.snackbarColor = "error";
          this.snackbar = true;
        } finally {
          this.loading = false;
        }
      } else {
        this.snackbarMessage = "No image available to download.";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },

    confirmSubmit() {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Save",
        message: "Are you sure you want to save the changes?",
        confirm: this.submitForm,
      };
    },

    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.snackbarMessage = "Please correct the errors in the form.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }
      this.loading = true;
      try {
        let uploadedImageUrl = this.imageUrl;
        if (this.imageFile) {
          const imageRef = storageRef(
            storage,
            `spares/${this.sparesId}_${Date.now()}_${this.imageFile.name}`
          );
          const snapshot = await uploadBytes(imageRef, this.imageFile);
          uploadedImageUrl = await getDownloadURL(snapshot.ref);
        }
        const spareData = {
          sparesId: this.sparesId.toString(),
          status: this.status,
          journalNumber: this.journalNumber,
          journalCreditNumber: this.status === "Completed" ? this.journalCreditNumber : "",
          shipmentNumber: this.status === "Completed" ? this.shipmentNumber : "",
          freeOfCharge: this.freeOfCharge,
          binNumber: this.binNumber ? parseInt(this.binNumber, 10) : null,
          createdDate: this.createdDate,
          projectedDate: this.projectedDate,
          reason: this.reason,
          qty: parseInt(this.qty, 10),
          code: this.code,
          description: this.description,
          imageUrl: uploadedImageUrl,
          comment: this.comment,
        };
        const spareDocRef = doc(db, "AwaitingSpares", this.spareDocId);
        await updateDoc(spareDocRef, spareData);
        this.snackbarMessage = "Spare updated successfully!";
        this.snackbarColor = "success";
        this.snackbar = true;
        localStorage.removeItem("selectedSpare");
        await this.fetchSpares();
        await this.getSpareData();
      } catch (error) {
        console.error("Error updating spare:", error);
        this.snackbarMessage = "Failed to update spare. Please try again.";
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.loading = false;
        this.confirmationDialog.visible = false;
      }
    },

    confirmBackNavigation() {
      this.confirmationDialog = {
        visible: true,
        title: "Confirm Navigation",
        message: "Are you sure you want to go back? Unsaved changes might be lost.",
        confirm: this.goBack,
      };
    },

    goBack() {
      this.confirmationDialog.visible = false;
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

/* Apply Montserrat Font */
body,
div,
span,
v-card-title,
v-card-text,
v-row,
v-col,
v-card,
v-btn,
v-icon,
v-img,
v-textarea {
  font-family: "Montserrat", sans-serif;
}

/* Card Styling */
.add-spares-card {
  box-shadow: 10px 10px 20px #1b1c1e, -10px -10px 20px #c4242b;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  transition: all 0.3s ease-in-out;
}

/* Input and Button Styling */
.montserrat-input {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
}

.montserrat-button {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}

/* Remove Padding */
.pa-0 {
  padding: 0px;
}

/* Back Button Styling */
.back-button {
  color: white;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 16px;
  transition: transform 0.3s ease-in-out;
}

.back-button:hover {
  transform: scale(1.1);
}

.back-button .v-icon {
  color: white;
}

/* Adjust the spacing between elements */
.ml-2 {
  margin-left: 8px;
}

/* Image Preview Styling */
.v-img {
  border-radius: 4px;
}

/* Image View Dialog Styling */
.v-dialog .v-card-text {
  padding: 0;
}

.v-dialog .v-img {
  width: 100%;
  height: auto;
}
</style>
